export default __webpack_public_path__ + "static/media/rfbin_2.5f5c72f6.png";